import { EWalletId } from '@ankr.com/provider';
import { LocalStorageKey } from '@ankr.com/auth';

export const getAuthWalletId = () => {
  const walletId = localStorage.getItem(LocalStorageKey.WalletId) ?? undefined;

  return walletId as EWalletId | undefined;
};
